<p style="display:none">{{title}}</p>
<form *ngIf="laborForm" [formGroup]="laborForm">
  <div class="row">
    <div class="col-sm-12 col-md-12 mb-2">
      <label style="font-size: 16px">¿Labora actualmente? <span class="required">*</span></label> &nbsp;&nbsp;
      <div class="radio-seleccion-govco form-check-inline ms-2 mt-4">
        <input type="radio" id="radio22" name="companyWorking" formControlName="companyWorking" value="1" (change)="showForm=true">
        <label for="radio22">SI</label>
      </div>
      <div class="radio-seleccion-govco form-check-inline ms-2">
        <input type="radio" id="radio23" name="companyWorking" formControlName="companyWorking" value="2" (change)="showForm=false">
        <label for="radio23">NO</label>
      </div>

    </div>

    <div class="row" *ngIf="showForm == true">

      <div class="col-sm-12 col-md-6">
        <div class="entradas-de-texto-govco">
          <label for="companyName">Nombre de la empresa<span class="required">*</span></label>
          <input formControlName="companyName" id="companyName"
                 [ngClass]="{'error': isTouchedField(laborForm, 'companyName')}"
                 aria-invalid="true" aria-describedby="servicesToProvide-note"
                 placeholder="Nombre de la empresa"
          />
          <span
            class="error-texto-govco alert-entradas-de-texto-govco" id="companyName-note" role="alert" aria-live="assertive">
            {{ getErrorMessage('companyName') }}
          </span>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="entradas-de-texto-govco">
          <label for="input-basico-i2">Dirección de la empresa<span class="required">*</span></label>
          <input formControlName="companyAddress"
                 [ngClass]="{'error': isTouchedField(laborForm, 'companyAddress')}"
                 aria-invalid="true" aria-describedby="servicesToProvide-note"
                 type="text" id="input-basico-i2" placeholder="Dirección de la empresa">
          <span
            class="error-texto-govco alert-entradas-de-texto-govco" id="companyAddress-note" role="alert" aria-live="assertive">
            {{ getErrorMessage('companyAddress') }}
          </span>
        </div>
      </div>

      <div class="col-sm-12 col-md-4">
        <div class="entradas-de-texto-govco">
          <label for="depaEmpresaId">Departamento Empresa<span class="required">*</span></label>
          <select class="form-select"
                  id="depaEmpresaId"
                  formControlName="companyDepartmentId"
                  [ngClass]="{'error': isTouchedField(laborForm, 'companyDepartmentId')}"
                  (change)="getMunicipios(this.laborForm.controls['companyDepartmentId'].value)"
          >
            <option value="" selected disabled >Seleccione</option>
            <option *ngFor="let departamento of departaments" [value]="departamento.idDepartamento">{{departamento.descripcion}}</option>
          </select>
          <span
            class="error-texto-govco alert-entradas-de-texto-govco" id="companyDepartmentId-note" role="alert" aria-live="assertive">
            {{ getErrorMessage('companyDepartmentId') }}
          </span>
        </div>
      </div>
      <div class="col-sm-12 col-md-4">
        <div class="entradas-de-texto-govco">
          <label for="munEmpresaId">Municipio Empresa<span class="required">*</span></label>
          <select class="form-select"
                  formControlName="companyMunicipalityId"
                  [ngClass]="{'error': isTouchedField(laborForm, 'companyMunicipalityId')}"
          >
            <option value="" disabled selected>Seleccione</option>
            <option  selected *ngFor="let municipio of municipios" [value]="municipio.idMunicipio">{{municipio.descripcion}}</option>
          </select>
          <span
            class="error-texto-govco alert-entradas-de-texto-govco" id="companyMunicipalityId-note" role="alert" aria-live="assertive">
            {{ getErrorMessage('companyMunicipalityId') }}
          </span>
        </div>
      </div>
      <div class="col-sm-12 col-md-4">
        <div class="entradas-de-texto-govco">
          <label for="telEmpresaId">Teléfono Empresa<span class="required">*</span></label>
          <input formControlName="companyPhone"
                 [ngClass]="{'error': isTouchedField(laborForm, 'companyPhone')}"
                 type="text" id="telEmpresaId" placeholder="Teléfono Empresa"
          />
          <span
            class="error-texto-govco alert-entradas-de-texto-govco" id="companyPhone-note" role="alert" aria-live="assertive">
            {{ getErrorMessage('companyPhone') }}
          </span>
        </div>
      </div>
      <div class="col-sm-12 col-md-4">
        <div class="entradas-de-texto-govco">
          <label for="celEmpresaId">Celular Empresa<span class="required">*</span></label>
          <input formControlName="companyCellPhone"
                 [ngClass]="{'error': isTouchedField(laborForm, 'companyCellPhone')}"
                 type="text" id="celEmpresaId" placeholder="Celular Empresa"
          />
          <span
            class="error-texto-govco alert-entradas-de-texto-govco" id="companyCellPhone-note" role="alert" aria-live="assertive">
            {{ getErrorMessage('companyCellPhone') }}
          </span>
        </div>
      </div>

    </div>
  </div>
</form>
